import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { DetailPopupModule } from '@iot-platform/iot-platform-ui';
import { Asset } from '@iot-platform/models/i4b';
import { TranslatePipe } from '@ngx-translate/core';

interface Hour {
  value: string;
  display: string;
}

@Component({
  imports: [DetailPopupModule, MatFormFieldModule, MatInputModule, MatSelectModule, FormsModule, TranslatePipe, FlexLayoutModule],
  selector: 'iot-platform-maps-map-panel-info-toolbox',
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './map-panel-info-toolbox.component.html'
})
export class MapPanelInfoToolboxComponent {
  asset = input<Asset>();
  loadRoutes = output<{ asset: Asset; daysToDisplay: string; minutesBetweenSegment: number; limit: number }>();

  hours: Hour[] = [
    { value: '60', display: '1 hour' },
    { value: '1440', display: '1 day' },
    { value: '2880', display: '2 days' },
    { value: '4320', display: '3 days' },
    { value: '7200', display: '5 days' },
    { value: '14400', display: '10 days' },
    { value: '43200', display: '30 days' }
  ];

  onLoadRoutes(selectedHours: Hour) {
    this.loadRoutes.emit({ asset: this.asset(), daysToDisplay: selectedHours.value, minutesBetweenSegment: 5, limit: 20000 });
  }
}
